<template>
  <v-footer
    dark
    padless
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="teal">
        <strong class="subheading">Get connected with us on social networks!</strong>

        <v-spacer></v-spacer>

        <v-btn
          v-for="icon in icons"
          :key="icon"
          class="mx-4"
          dark
          icon
          :href="icon.link"

        >
          <v-icon size="24px">
            {{ icon.icon }}
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="py-2 white--text text-center">
        {{ new Date().getFullYear() }} — <strong>Ezequiel Flores</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
  export default {
    data: () => ({
      icons: [
        {
          icon:  'mdi-github',
          link: 'https://github.com/jef586'
        },
        { 
          icon:  'mdi-linkedin',
          link: 'https://www.linkedin.com/in/ezequiel-flores-4343391a8/'
        },
        { 
          icon:   'mdi-gitlab',
          link: 'https://gitlab.com/jeftikas'
        },

       
        
       
      ],
    }),
  }
</script>